module.exports = __webpack_public_path__ + "static/3_SINGLE-268b83bdf28fed08b831f20274d1418a.png";